import img1 from 'assets/illustrations/cooperations/first.png';
import img2 from 'assets/illustrations/cooperations/second.svg';
import img3 from 'assets/illustrations/cooperations/third.svg';

export const itSupportCardsData = [
  {
    tag: 'Первая линия поддержки',
    title: 'Решение проблем конечных пользователей',
    list: [
      'Проблемы с учётными записями и доступом;',
      'Настройка ПК и внешних устройств;',
      'Передача сложных заявок специалистам.',
    ],
    img: img1,
  },
  {
    tag: 'Вторая линия поддержки',
    title: 'Работа на уровне пользователя и приложения',
    list: [
      'Сложные проблемы пользователей, настройка приложений и устранение неполадок;',
      'Основные инфраструктурные задачи;',
      'Обновления и резервное копирование сервера.',
    ],
    img: img2,
  },
  {
    tag: 'Третья линия поддержки',
    title: 'Настройка приложений и инфраструктуры',
    list: [
      'Настройка расписания резервного копирования, правил хранения и аварийного восстановления;',
      'Виртуализация серверов, проектирование и конфигурации баз данных;',
      'Исправление ошибок.',
    ],
    img: img3,
  },
];

export const maintenanceSupportCardsData = [
  {
    tag: 'Первая линия поддержки',
    title: 'Решение проблем конечных пользователей',
    list: [
      'Проблемы с паролем и доступом;',
      'Настройка внешних устройств;',
      'Передача сложного случая на следующую линию.',
    ],
    img: img1,
  },
  {
    tag: 'Вторая линия поддержки',
    title: 'Работа на уровне пользователя и приложения',
    list: [
      'Сложные проблемы пользователей, настройки приложений и устранение неполадок;',
      'Основные инфраструктурные задачи;',
      'Обновления и резервное копирование сервера.',
    ],
    img: img2,
  },
  {
    tag: 'Третья линия поддержки',
    title: 'Настройка приложений и инфраструктуры',
    list: [
      'Графики резервного копирования, хранение, аварийное восстановление;',
      'Виртуализация серверов, проектирование и настройка баз данных;',
      'Исправление ошибок.',
    ],
    img: img3,
  },
];
